<template>
  <v-container class="fheigth" fluid>
    <div class="bgblack"></div>
    <v-row justify="center" align="center">
      <v-card width="350">
        <v-card-text>
          <div class="avatar">
            <img src="@/assets/loginlogo.png" alt />
          </div>
          <div class="title">
            <h2 class="title">LOGAR NO SISTEMA</h2>
          </div>
          <v-col cols="12" sm="12">
            <v-text-field
              prepend-inner-icon="mdi-account"
              v-model="userData.user_login"
              label="Usuário:"
              @keypress.enter="$refs.pwd.focus()"
            />
          </v-col>
          <v-col cols="12" sm="12">
            <v-text-field
              prepend-inner-icon="mdi-lock"
              v-model="userData.user_password"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="input-10-1"
              label="Senha"
              ref="pwd"
              @click:append="show = !show"
              @keypress.enter="login"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-btn
              height="45"
              block
              depressed
              color="primary"
              :loading="loader"
              @click="login"
              :disabled="
                userData.user_login && userData.user_password ? false : true
              "
              >ENTRAR</v-btn
            >
          </v-col>
        </v-card-text>
      </v-card>
    </v-row>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    show: false,
    loader: false,
    userData: {
      user_login: "",
      user_password: "",
    },
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    if (localStorage.getItem("token")) {
      this.$router.push("/dashboard");
    } else {
      this.$router.push("/login");
    }
  },
  methods: {
    login() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.userData.user_login = this.userData.user_login.trim();
      this.userData.user_password = this.userData.user_password.trim();
      this.$http
        .post("/login", this.userData)
        .then((r) => {
          if (r.data.success) {
            localStorage.setItem("token", r.data.token);
            const dataUser = r.data.user[0];
            delete dataUser.user_password;
            if (r.data.user[0].table_key && r.data.user[0].table_id) {
              this.$http(
                `/${r.data.user[0].table_key}/${r.data.user[0].table_id}`
              ).then((res) => (dataUser.ref = res.data[0]));
            }
            this.$http(`/access-groups/${r.data.user[0].group_id}`)
              .then((r) =>
                this.$store.dispatch(
                  "userPermissions",
                  JSON.parse(r.data[0].group_permissions)
                )
              )
              .catch(() => this.$store.dispatch("userPermissions", []));
            this.snack.show = true;
            this.snack.message = r.data.success;
            this.snack.color = "success";

            this.$http.post("/supplies/repairvalues").then(() => {});
            setTimeout(() => {
              localStorage.setItem("userData", JSON.stringify(dataUser));
              this.$store.dispatch("userData", dataUser);
              this.loader = false;
              this.$store.dispatch("setLoader", this.loader);
              window.location.reload(1);
            }, 2000);
          } else {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = r.data.error;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", this.loader);
          }
        })
        .catch(() => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message =
            "SEM CONEXÃO COM O SERVIDOR. ENTRE EM CONTATO COM O SUPORTE! ";
          this.snack.color = "warning";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
  },
};
</script>

<style>
.fheigth {
  background: url("../../assets/bg.png") no-repeat;
  background-size: cover;
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
}

.avatar {
  position: absolute;
  top: -40px;
  left: 140px;
  border-radius: 50%;
  background: #0388e5;

  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar img {
  width: 90px;
  height: 90px;
}

.bgblack {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.title {
  text-align: center;
  width: 100%;
  margin: 40px 0 0 0;
}
</style>